require.register("confirmation/tableCtrl", function(exports, require, module){
  $0
  
});

